import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EventService } from '../../core/services/event.service';

//Logout
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

// Language
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from 'src/app/core/services/storage.service';
import { CommonCommunicationService } from 'src/app/core/services/commonCommunication.service';
import { UserService } from 'src/app/core/services/user.service';
// import { SocketService } from 'src/app/core/services/socket.service';
import { IntegrationService } from 'src/app/core/services/integration.service';
import { CommonUtilityService } from 'src/app/core/services/commonUtility.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  element: any;
  mode: string | undefined;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  flagvalue: any;
  valueset: any;
  countryName: any;
  cookieValue: any;
  userInfo: any;
  activeShopId: any = null;
  userDetails: any;
  shopList: any;
  shopId: any;
  shopStatus: any;
  isTechRole: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private eventService: EventService,
    public languageService: LanguageService,
    public _cookiesService: CookieService,
    public translate: TranslateService,
    private router: Router,
    private storageService: StorageService,
    private ccs: CommonCommunicationService,
    private userService: UserService,
    // private messageService: SocketService,
    private integrationService: IntegrationService,
    private commonUtilityService: CommonUtilityService
  ) {}

  ngOnInit(): void {
    this.ccs.getUserData().subscribe((res) => {
      if (res) {
        this.userDetails = res;
        if (this.userDetails.shopId && this.userDetails.shopId.length) {
          if(this.userDetails.role === 'Tech Role') {
            this.isTechRole = true;
            this.checkEnvironment();
          } else {
            this.checkEnvironment();
          }
        }
      }
    });
    this.ccs.getActiveShopId().subscribe((res) => {
      if (res) {
        this.activeShopId = res;
        this.shopId = res;
        // this.getShopList();
        this.getShopById();
        this.getNotification();

        setInterval(() => {
          this.getNotification();
        }, 60000);
      }
    });
    this.element = document.documentElement;

    // Cookies wise Language set
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = 'assets/images/flags/us.svg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
  }
  notificationList: any = [];
  unreadCount: any = 0;

  updateNotificationStatus(item: any) {
    let payload = {
      notificationId: item._id,
    };
    this.integrationService
      .updateNotificationStatus(payload)
      .subscribe((res) => {
        this.getNotification();
        if (item.notification.dataBody.resource === 'ORDER') {
          this.router.navigateByUrl(
            `/order/order-details?orderId=${item.notification.dataBody.resourceId}`
          );
        }
      });
  }

  getNotification() {
    this.integrationService
      .getNotification(this.shopId, 0, 100)
      .subscribe((res) => {
        this.notificationList = res.data;
        let unreadNotification = this.notificationList.filter(
          (item: any) => !item.isOpened
        );
        this.unreadCount = unreadNotification.length;
      });
  }

  changeShop(event: any) {
    let newShop = this.shopList.filter(
      (item: any) => item.businessName == event
    )[0];
    // this.messageService.leaveRoom(this.shopId)
    this.ccs.setActiveShopId(newShop._id);
  }
  getShopList() {
    this.userService
      .getShopListByIds(this.userDetails.shopId)
      .subscribe((res: any) => {
        this.shopList = res.result.filter((item: any) =>
          this.userDetails.shopId.includes(item._id)
        );
        this.activeShopId = res.result.filter(
          (item: any) => item._id == this.activeShopId
        );
        // this.shopStatus = res.result.closeShop

        this.activeShopId = this.activeShopId[0].businessName;
      });
  }

  getShopById() {
    this.userService.getShopById(this.shopId).subscribe((res) => {
      this.shopStatus = res.result.closeShop;
    });
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  adminEnvironment = '';
  checkEnvironment() {
    if (environment.environment === 'staging') {
      this.adminEnvironment = 'staging';
    }
    if (environment.environment === 'production' && this.isTechRole) {
      this.adminEnvironment = 'production';
    }
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Topbar Light-Dark Mode Change
   */
  changeMode(mode: string) {
    this.mode = mode;
    this.eventService.broadcast('changeMode', mode);

    switch (mode) {
      case 'light':
        document.body.setAttribute('data-layout-mode', 'light');
        document.body.setAttribute('data-sidebar', 'light');
        break;
      case 'dark':
        document.body.setAttribute('data-layout-mode', 'dark');
        document.body.setAttribute('data-sidebar', 'dark');
        break;
      default:
        document.body.setAttribute('data-layout-mode', 'light');
        break;
    }
  }

  /***
   * Language Listing
   */
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' },
    { text: 'Española', flag: 'assets/images/flags/spain.svg', lang: 'es' },
    { text: 'Deutsche', flag: 'assets/images/flags/germany.svg', lang: 'de' },
    { text: 'Italiana', flag: 'assets/images/flags/italy.svg', lang: 'it' },
    { text: 'русский', flag: 'assets/images/flags/russia.svg', lang: 'ru' },
    { text: '中国人', flag: 'assets/images/flags/china.svg', lang: 'ch' },
    { text: 'français', flag: 'assets/images/flags/french.svg', lang: 'fr' },
  ];

  /***
   * Language Value Set
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  logout() {
    this.storageService.clear();
    this.router.navigate(['/auth/login']);
  }

  getUserInfo() {
    this.userInfo = this.storageService.getLocalStorage('admin_info');
  }

  navigateToMyAccount() {
    this.router.navigate(['profile']);
  }

  navigateToStoreSetting() {
    this.router.navigate(['profile/store-setting']);
  }
  navigateToNewStore() {
    this.router.navigate(['/auth/get-started']);
  }
  generateTempToken(){
    let payload = {
      email: this.userDetails.email,
    };
    this.userService.getTemporaryToken(payload).subscribe((response) => {
      const token = response.token;
      navigator.clipboard.writeText(token)
        .then(() => {
          this.showSuccessMessage('Token copied to clipboard');
        })
        .catch(err => {
          this.showFailedMessage(`Failed to copy token to clipboard: ${err}`);
        });
    });
  }

  showSuccessMessage(msg: any) {
    this.commonUtilityService.showSuccess(msg)
  }
  showFailedMessage(msg: any){
    this.commonUtilityService.showDanger(msg)
  }

  updateShopStatus() {
    let payload = {
      _id: this.shopId,
      closeShop: !this.shopStatus,
    };

    this.userService.updateShop(payload).subscribe((res) => {
      this.getShopById();
    });
  }
}
